// extracted by mini-css-extract-plugin
export default {"root":"style_root__p5r3Y","heading":"style_heading__B7zLj","info":"style_info__swtOv","infoAccent":"style_infoAccent__iFcfw"};